import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ListItem\GetListItemsController::__invoke
* @see app/Http/Controllers/ListItem/GetListItemsController.php
* @route '/api/list-item'
*/
const GetListItemsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListItemsController.url(options),
    method: 'get',
})

GetListItemsController.definition = {
    methods: ["get","head"],
    url: '/api/list-item',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ListItem\GetListItemsController::__invoke
* @see app/Http/Controllers/ListItem/GetListItemsController.php
* @route '/api/list-item'
*/
GetListItemsController.url = (options?: RouteQueryOptions) => {
    return GetListItemsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListItem\GetListItemsController::__invoke
* @see app/Http/Controllers/ListItem/GetListItemsController.php
* @route '/api/list-item'
*/
GetListItemsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListItemsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListItem\GetListItemsController::__invoke
* @see app/Http/Controllers/ListItem/GetListItemsController.php
* @route '/api/list-item'
*/
GetListItemsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetListItemsController.url(options),
    method: 'head',
})

export default GetListItemsController